/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Navigation/Home': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M27.76 15.74L16.093 4.074a.25.25 0 0 0-.354 0L4.073 15.741a.25.25 0 0 0 0 .354l1.06 1.06a.25.25 0 0 0 .354 0l1.43-1.43v9.336c0 .139.112.25.248.25h1.503a.248.248 0 0 0 .248-.25V13.725l7-7 7 7v9.586H11.858a.25.25 0 0 0-.226.145l-.691 1.5a.25.25 0 0 0 .226.355h13.5a.25.25 0 0 0 .25-.25v-9.336l1.43 1.43a.249.249 0 0 0 .352 0l1.061-1.06a.25.25 0 0 0 0-.354"/>'
  }
})
